import React from 'react';
import { Box } from '@mui/material';
import {
    Navigate,
    Route,
    Routes,
    useLocation
} from 'react-router-dom';
import IgdChartsContainer from '../Common/IgdChartsContainer';
import CadUniqueWrapper from './CadUniqueResults';



const CadUnique = (props) => {
    const location = useLocation();
    
    const titleMap = {
        [`/governanceroom/${props.dashboardPath}/${props.menuPath}/cad-un-results`]:
            'Resultados Gerais do Cadastro Único',
    };

    return (
        <Box>
            <Box className="content">
                <IgdChartsContainer
                    title={titleMap[location.pathname]}
                    className="services-container-dashboards"
                >
                    <Routes>
                        <Route
                            path="/"
                            element={<Navigate to="cad-un-results" replace />}
                        />
                        <Route
                            path="cad-un-results"
                            element={<CadUniqueWrapper />}
                        />
                    </Routes>
                </IgdChartsContainer>
            </Box>
        </Box>
    );
};

export default CadUnique;
